import { Controller } from "@hotwired/stimulus"

// Dispatches a window event so a control outside the trip-map controller element
// (e.g. the trip title map icon) can reset the map to all stops.
export default class extends Controller {
  static values = { event: String }

  fire(event) {
    event.preventDefault()
    if (!this.eventValue) return

    window.dispatchEvent(new CustomEvent(this.eventValue))
  }
}
